import {
	PRODUCTS_INFO_ERROR_CLEAR,
	TRANSFER_CHECK_FETCH_INVENTORY_ORDER_REQUEST,
	TRANSFER_CHECK_FETCH_INVENTORY_ORDER_RESPONSE,
	TRANSFER_CHECK_FETCH_INVENTORY_ORDER_ERROR,
	TRANSFER_CHECK_CONFIRM_RECEIVED_PACKAGE_REQUEST,
	TRANSFER_CHECK_CONFIRM_RECEIVED_PACKAGE_RESPONSE,
	TRANSFER_CHECK_CONFIRM_RECEIVED_PACKAGE_ERROR,
	TRANSFER_CHECK_FINISH_REQUEST,
	TRANSFER_CHECK_FINISH_RESPONSE,
	TRANSFER_CHECK_FINISH_ERROR,
	TRANSFER_CHECK_STORE_RESET,
	TRANSFER_CHECK_FETCH_DC_ORDERS_RESPONSE,
	TRANSFER_CHECK_FETCH_DC_ORDERS_REQUEST,
	TRANSFER_CHECK_FETCH_DC_ORDERS_ERROR,
	TRANSFER_CHECK_FETCH_RECEIVED_ORDERS_REQUEST,
	TRANSFER_CHECK_FETCH_RECEIVED_ORDERS_RESPONSE,
	TRANSFER_CHECK_FETCH_RECEIVED_ORDERS_ERROR,
	TRANSFER_CHECK_CONFIRM_ARRIVAL_DC_ORDERS_REQUEST,
	TRANSFER_CHECK_CONFIRM_ARRIVAL_DC_ORDERS_RESPONSE,
	TRANSFER_CHECK_CONFIRM_ARRIVAL_DC_ORDERS_ERROR,
	TRANSFER_CHECK_UNDO_ORDER_CONFIRMATION_ERROR,
	TRANSFER_CHECK_UNDO_ORDER_CONFIRMATION_REQUEST,
	TRANSFER_CHECK_UNDO_ORDER_CONFIRMATION_RESPONSE,
} from 'constants/ActionTypes';

const removeArrivedOrders = ({ orders }, { payload }) =>
	'number' in payload ? orders.filter(({ number }) => number !== payload.number) : orders;

const removeOrderFromBuckets = (receivedOrdersByBucket, { payload }) => {
	if (!receivedOrdersByBucket || !('number' in payload)) {
		return receivedOrdersByBucket;
	}
	return Object.keys(receivedOrdersByBucket).reduce((byBucket, bucket) => {
		const receivedOrders = receivedOrdersByBucket[bucket];
		const orders = receivedOrders && receivedOrders.orders.filter(order => order !== payload.number);
		return {
			...byBucket,
			[bucket]: orders && orders.length ? { ...receivedOrders, orders } : null,
		};
	}, {});
};

const addSegregatedItem = (segregatedItems, { sku, quantity, batch }) => {
	const items = segregatedItems || [];
	if (!items.some(item => item.sku === sku)) {
		return [...items, { sku, quantity, batch }];
	}
	return items.map(item =>
		item.sku === sku ? { ...item, quantity: item.quantity + quantity, batch } : item
	);
};

const addPackageToReceivedOrders = (receivedOrders, packageToBeAdded, response) => {
	if (response && response.segregated) {
		return {
			...receivedOrders,
			totalQuantitySegregated:
				(receivedOrders.totalQuantitySegregated || 0) + packageToBeAdded.quantity,
			segregatedItems: addSegregatedItem(receivedOrders.segregatedItems, packageToBeAdded),
			receivedBarcodes: packageToBeAdded.barcode ? [...receivedOrders.receivedBarcodes, packageToBeAdded.barcode] : receivedOrders.receivedBarcodes,
		};
	}
	const index = receivedOrders.transferInItems.findIndex(item => item.sku === packageToBeAdded.sku);
	if (index !== -1) {
		receivedOrders.transferInItems[index].quantity += packageToBeAdded.quantity;
		receivedOrders.transferInItems[index].batch = packageToBeAdded.batch;
	} else {
		receivedOrders.transferInItems.push(packageToBeAdded)
	}
	return {
		...receivedOrders,
		totalQuantityReceived: receivedOrders.totalQuantityReceived + packageToBeAdded.quantity,
		receivedBarcodes: packageToBeAdded.barcode ? [...receivedOrders.receivedBarcodes, packageToBeAdded.barcode] : receivedOrders.receivedBarcodes,
	};
}

const addPackageToBucket = ({ receivedOrdersByBucket, packageToBeAdded }, response) => {
	const receivedOrders = receivedOrdersByBucket && receivedOrdersByBucket[packageToBeAdded.bucket];
	if (!receivedOrders) {
		return receivedOrdersByBucket;
	}
	return {
		...receivedOrdersByBucket,
		[packageToBeAdded.bucket]: addPackageToReceivedOrders(receivedOrders, packageToBeAdded, response),
	};
};

const initialState = {
	products: {},
	loading: false,
	error: null,
	success: false,
	receivedOrdersByBucket: null,
	order: null,
	packageToBeAdded: null,
	waitingConfirmation: false,
	waitingFinish: false,
	done: false,
	orders: [],
	ordersLoading: false,
};

const TransferCheck = (state = initialState, action) => {
	switch (action.type) {
		case TRANSFER_CHECK_FETCH_INVENTORY_ORDER_REQUEST:
			return {
				...state,
				loading: true,
				done: false,
				error: null,
			};
		case TRANSFER_CHECK_FETCH_INVENTORY_ORDER_RESPONSE:
			return {
				...state,
				order: action.payload,
				done: false,
				loading: false,
				error: null,
			};
		case TRANSFER_CHECK_FETCH_INVENTORY_ORDER_ERROR:
			return {
				...state,
				loading: false,
				done: false,
				error: action.payload.data,
			};
		case TRANSFER_CHECK_CONFIRM_RECEIVED_PACKAGE_REQUEST:
			return {
				...state,
				waitingConfirmation: true,
				packageToBeAdded: action.payload,
				done: false,
				error: null,
			};
		case TRANSFER_CHECK_CONFIRM_RECEIVED_PACKAGE_RESPONSE:
			return {
				...state,
				receivedOrdersByBucket: addPackageToBucket(state, action.payload),
				waitingConfirmation: false,
				done: false,
				error: null,
			};
		case TRANSFER_CHECK_CONFIRM_RECEIVED_PACKAGE_ERROR:
			return {
				...state,
				waitingConfirmation: false,
				done: false,
				error: action.payload.data,
			};
		case TRANSFER_CHECK_FINISH_REQUEST:
			return {
				...state,
				waitingFinish: true,
				done: false,
				error: null,
			};
		case TRANSFER_CHECK_FINISH_RESPONSE:
			return {
				...state,
				receivedOrdersByBucket: null,
				waitingFinish: false,
				done: true,
				error: null,
			};
		case TRANSFER_CHECK_FINISH_ERROR:
			return {
				...state,
				waitingFinish: false,
				done: false,
				error: action.payload.data,
			};
		case TRANSFER_CHECK_STORE_RESET:
			return {
				...state,
				loading: false,
				error: null,
				success: false,
				order: null,
				waitingConfirmation: false,
				done: false,
			};
		case TRANSFER_CHECK_FETCH_DC_ORDERS_REQUEST:
			return {
				...state,
				orders: [],
				ordersLoading: true,
				error: null,
			};
		case TRANSFER_CHECK_FETCH_DC_ORDERS_RESPONSE:
			return {
				...state,
				orders: action.payload,
				ordersLoading: false,
			};
		case TRANSFER_CHECK_FETCH_DC_ORDERS_ERROR:
			return {
				...state,
				orders: [],
				ordersLoading: false,
				error: action.payload,
			};
		case TRANSFER_CHECK_FETCH_RECEIVED_ORDERS_REQUEST:
			return {
				...state,
				receivedOrdersByBucket: null,
				loading: true,
				error: null,
			};
		case TRANSFER_CHECK_FETCH_RECEIVED_ORDERS_RESPONSE:
			return {
				...state,
				receivedOrdersByBucket: action.payload,
				loading: false,
			};
		case TRANSFER_CHECK_FETCH_RECEIVED_ORDERS_ERROR:
			return {
				...state,
				receivedOrdersByBucket: null,
				loading: false,
				error: action.payload.error,
			};
		case TRANSFER_CHECK_CONFIRM_ARRIVAL_DC_ORDERS_REQUEST:
			return {
				...state,
				ordersLoading: true,
				error: null,
			};
		case TRANSFER_CHECK_CONFIRM_ARRIVAL_DC_ORDERS_RESPONSE:
			return {
				...state,
				orders: removeArrivedOrders(state, action),
				ordersLoading: false,
			};
		case TRANSFER_CHECK_CONFIRM_ARRIVAL_DC_ORDERS_ERROR:
			return {
				...state,
				ordersLoading: false,
				error: action.payload,
			};
		case TRANSFER_CHECK_UNDO_ORDER_CONFIRMATION_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		case TRANSFER_CHECK_UNDO_ORDER_CONFIRMATION_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case TRANSFER_CHECK_UNDO_ORDER_CONFIRMATION_RESPONSE:
			return {
				...state,
				loading: false,
				receivedOrdersByBucket: removeOrderFromBuckets(state.receivedOrdersByBucket, action),
			};
		case PRODUCTS_INFO_ERROR_CLEAR:
			return {
				...state,
				ordersLoading: false,
				loading: false,
				error: null,
			};
		default:
			return state;
	}
};

export default TransferCheck;
